<template>
  <v-layout align-center justify-center>
    <v-flex xs12 sm8>
      <v-alert color="error" v-model="hasErrors" class="errors mb-4">
        <div v-for="(error, index) in errors" :key="index">{{ error }}</div>
      </v-alert>
      <v-form v-on:submit.prevent="submitRegistration()">
        <v-text-field
          solo
          label="Entreprise"
          v-model="company"
          required
          class="mb-4"
        ></v-text-field>
        <v-text-field
          solo
          label="Prénom"
          v-model="firstname"
          required
          class="mb-4"
        ></v-text-field>
        <v-text-field
          solo
          label="Nom"
          v-model="lastname"
          required
          class="mb-4"
        ></v-text-field>
        <v-text-field
          solo
          label="Email"
          v-model="email"
          required
          class="mb-4"
        ></v-text-field>
        <v-text-field
          solo
          label="Téléphone"
          v-model="phone"
          required
          class="mb-4"
        ></v-text-field>
        <div class="mb-3">
          Pour créer un compte sur Weview, vous devez accepter nos <a @click.stop="agreementModal = true">Conditions Générales d'Utilisation</a>.
        </div>
        <v-checkbox
          :label="`J'accepte les conditions d'utilisation`"
          v-model="agreement"
        ></v-checkbox>
        <v-layout align-center justify-center>
          <v-btn type="submit" round large color="info">
            C'est parti
          </v-btn>
        </v-layout>
      </v-form>
    </v-flex>
    <v-dialog
      v-model="agreementModal"
      fullscreen
      transition="dialog-bottom-transition"
      :overlay="false"
      scrollable
    >
      <v-card tile>
        <v-toolbar >
          <v-toolbar-title>Conditions Générales d'Utilisation Weview</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="agreementModal = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <agreement-conditions />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';
import wButton from '@/components/generics/WButton';
import agreementConditions from '@/components/AgreementConditions';
import emailValidator from 'email-validator';

export default {
  name : `newRegistration`,
  data : () => ({
    company        : ``,
    firstname      : ``,
    lastname       : ``,
    agreement      : false,
    email          : ``,
    phone          : ``,
    agreementModal : false,
  }),
  computed : {
    ...mapState({
      errors : state => state.uiState.errors,
    }),
    hasErrors () {
      return this.errors.length > 0;
    },
  },
  methods : {
    submitRegistration () {
      const errors       = [];
      const registration = {
        companyLabel  : this.company || null,
        userFirstname : this.firstname || null,
        userLastname  : this.lastname || null,
        userEmail     : this.email || null,
        userPhone     : this.phone || null,
      };

      if (!registration.companyLabel) { errors.push(`Vous devez saisir une entreprise`); }
      if (!registration.userFirstname) { errors.push(`Vous devez saisir un prénom`); }
      if (!registration.userLastname) { errors.push(`Vous devez saisir un nom`); }
      if (!registration.userEmail) { errors.push(`Vous devez saisir un email`); }
      if (!registration.userPhone) { errors.push(`Vous devez saisir un téléphone`); }
      if (registration.userEmail && !emailValidator.validate(registration.userEmail)) { errors.push(`Vous avez saisi un email erroné`); }
      if (!this.agreement) { errors.push(`Vous devez accepter les CGU`); }

      this.$store.dispatch(`setErrors`, errors);

      if (errors.length) { return; }

      this.$store.dispatch(`createFreeRegistration`, registration)
      .then(() => this.$store.dispatch(`successCheckEmails`))
      .then(() => {
        // google analytics event
        if (typeof ga === `function`) { // eslint-disable-line
          ga('send', {// eslint-disable-line
            hitType: `event`,
            eventCategory: `Insciption au freemium`,
            eventAction: `Validation du formulaire d'inscription au freemium`,
          });
        }
      })
      .catch(e => this.$store.dispatch(`serverError`, e));
    },
  },
  components : {
    wButton,
    agreementConditions,
  },
  mounted () {
    setTimeout(() => this.$store.dispatch(`isLoading`, false), 1000);
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// NewRegistration.vue?0ded24a0